import { useEffect, useRef } from 'react'

import { useSchedule } from '../../../hooks/ScheduleContext'

import { AddBlockButton } from './Buttons/AddBlockButton'
import { CalendarOptionsButton } from './Buttons/CalendarOptionsButton'
import { TaxiDogButton } from './Buttons/TaxiDogButton'
import { ServiceQueueButton } from './Buttons/ServiceQueueButton'
import { ScheduleFilter } from './ScheduleFilter'
import { StatusSummary } from './StatusSummary'

import { Container, Controls, DateBox, ButtonBox } from './styles'
import { Slider } from './Slider'
import { WeekStrip } from './WeekStrip'
import { useThemes } from '../../../providers/theme'
import SelectGap from './SelectGap'
import { motion } from "framer-motion";
import { useMenu } from '../../../store/global/useMenu'

export function Header() {
  const menuSize = useMenu(st => st.data.size)

  const { updateConfig } = useSchedule()
  const { theme } = useThemes()

  /**
   * A faixa laranja dos profissionais (Head) tambem e sticky. Para ela parar
   * LOGO ABAIXO deste cabecalho em vez de deslizar por tras dele, precisa
   * saber a altura dele — que muda quando a barra de acoes quebra linha em
   * tela estreita ou quando a faixa de dias encolhe. Publicamos a medida numa
   * variavel CSS e o Head so a consome.
   */
  const cabecalhoRef = useRef(null)

  useEffect(() => {
    const elemento = cabecalhoRef.current
    if (!elemento) return

    const publicaAltura = () => {
      const altura = Math.round(elemento.getBoundingClientRect().height)
      document.documentElement.style.setProperty('--agenda-cabecalho', `${altura}px`)
    }

    publicaAltura()

    if (typeof ResizeObserver === 'undefined') {
      window.addEventListener('resize', publicaAltura)
      return () => window.removeEventListener('resize', publicaAltura)
    }

    const observador = new ResizeObserver(publicaAltura)
    observador.observe(elemento)
    return () => observador.disconnect()
  }, [])

  const handleFilter = (filterData) => {
    // Implementar lógica de filtro na agenda
    console.log('Filtros aplicados:', filterData)
    // Aqui você pode atualizar o contexto da agenda com os filtros
    updateConfig({ filters: filterData })
  }

  const handleClearFilter = () => {
    // Limpar filtros da agenda
    console.log('Filtros limpos')
    updateConfig({ filters: null })
  }

  return (
    <motion.div
      initial={{ width: `calc(100vw - 2rem - ${menuSize})` }}
      animate={{ width: `calc(100vw - 2rem - ${menuSize})` }}
      transition={{ duration: 0.3 }}
      /* o topo fica fixo: a agenda vai das 07:00 as 21:00 e trocar o dia ou o
         intervalo e coisa que se faz o tempo todo. `left: 0` mantem ele parado
         na rolagem lateral, para os botoes nao sairem de vista quando a loja
         tem muitos profissionais e a grade desliza. */
      style={{ position: 'sticky', top: 0, left: 0, zIndex: 25 }}
      ref={cabecalhoRef}
    >
      <Container className='w-full pr-4'>
        <WeekStrip />
        <Controls>
          <DateBox>
            <Slider />
            <SelectGap />
          </DateBox>
          <ButtonBox>
            {theme === 'draMei' && <ServiceQueueButton />}
            {theme === 'petland' && <TaxiDogButton />}
            {theme === 'petland' && <AddBlockButton />}
            {/*
              * No lugar do botao de Pre Agendamento entrou o informativo do
              * dia. O pre-agendamento continua acessivel pela rota
              * /pre-agendamento e pelo modal dentro da propria agenda — o que
              * saiu foi o atalho daqui, nao a funcao.
              */}
            <StatusSummary theme={theme} />
            <ScheduleFilter
              onFilter={handleFilter}
              onClear={handleClearFilter}
            />
          </ButtonBox>
        </Controls>
      </Container>
    </motion.div>

  )
}
